import React from "react";
import PropTypes from "prop-types";
import PerfectScrollbar from "perfect-scrollbar";
import { NavLink } from "react-router-dom";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";
import Icon from "@material-ui/core/Icon";
import SettingsApplications from "@material-ui/icons/SettingsApplications";
import iseas from "assets/img/logo_white.svg";

// core components
import UpdateProfile from "../Common/FevoModels/UpdateProfile.jsx";
import ResetPassword from "../Common/FevoModels/ResetPassword";

import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";

import LogoutImpl from "../Common/Model/Logout";
import { getData } from "../../utils/util";

// import avatar from "assets/img/default-avatar.png";

var ps;

class SidebarWrapper extends React.Component {
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  render() {
    const { className, user, headerLinks, links } = this.props;
    return (
      <div className={className} ref="sidebarWrapper">
        {user}
        {headerLinks}
        {links}
      </div>
    );
  }
}

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      openComponents: this.activeRoute("/components"),
      openForms: this.activeRoute("/forms"),
      openTables: this.activeRoute("/tables"),
      openMaps: this.activeRoute("/maps"),
      openPages: this.activeRoute("-page"),
      miniActive: true,
      show: false,
      showProfileModel: false,
      showResetPassModel: false
    };
    this.activeRoute.bind(this);
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    if (
      (routeName === "/dashboard/products" &&
        this.props.location.pathname === "/dashboard/addproducts") ||
      (routeName === "/dashboard/products" &&
        this.props.location.pathname === "/dashboard/viewproducts") ||
      (routeName === "/dashboard/products" &&
        this.props.location.pathname === "/dashboard/editproducts")
    ) {
      return true;
    }
    if (
      (routeName === "/dashboard/imagesgallery" &&
        this.props.location.pathname === "/dashboard/addimages") ||
      (routeName === "/dashboard/imagesgallery" &&
        this.props.location.pathname === "/dashboard/viewimage") ||
      (routeName === "/dashboard/imagesgallery" &&
        this.props.location.pathname === "/dashboard/editimage")
    ) {
      return true;
    }
    if (
      (routeName === "/dashboard" &&
        this.props.location.pathname === "/dashboard/addusers") ||
      (routeName === "/dashboard" &&
        this.props.location.pathname === "/dashboard/viewusers") ||
      (routeName === "/dashboard" &&
        this.props.location.pathname === "/dashboard/editusers") ||
      (routeName === "/dashboard" &&
        this.props.location.pathname === "/dashboard/changepassword")
    ) {
      return true;
    }
    if (
      (routeName === "/dashboard/managefaq" &&
        this.props.location.pathname === "/dashboard/viewfaq") ||
      (routeName === "/dashboard/managefaq" &&
        this.props.location.pathname.search("/dashboard/viewfaqcat") === 0) ||
      (routeName === "/dashboard/managefaq" &&
        this.props.location.pathname.search("/dashboard/addfaq") === 0)
    ) {
      return true;
    }
    if (
      (routeName === "/dashboard/managecontent" &&
        this.props.location.pathname === "/dashboard/viewcontent") ||
      (routeName === "/dashboard/managecontent" &&
        this.props.location.pathname === "/dashboard/editcontent")
    ) {
      return true;
    }
    if (
      (routeName === "/dashboard/manageinappnotification" &&
        this.props.location.pathname === "/dashboard/addemailnotification") ||
      (routeName === "/dashboard/manageinappnotification" &&
        this.props.location.pathname === "/dashboard/addsmsnotification") ||
      (routeName === "/dashboard/manageinappnotification" &&
        this.props.location.pathname === "/dashboard/addinappnotification") ||
      (routeName === "/dashboard/manageinappnotification" &&
        this.props.location.pathname === "/dashboard/viewappnotification")
    ) {
      return true;
    }
    return this.props.location.pathname.indexOf(routeName) > -1 ? true : false;
  }
  openCollapse(collapse) {
    var st = {};
    st[collapse] = !this.state[collapse];
    this.setState(st);
  }

  showHideLogout = () => {
    this.setState({
      show: !this.state.show
    });
  };

  showHideProfileModel = () => {
    this.setState({
      showProfileModel: !this.state.showProfileModel
    });
  };

  showHideResetPassModel = () => {
    this.setState({
      showResetPassModel: !this.state.showResetPassModel
    });
  };

  openResetPassword = () => {
    this.setState({
      showProfileModel: false,
      showResetPassModel: true
    });
  };

  render() {
    const { classes, color, image, routes, bgColor, rtlActive } = this.props;
    const itemText =
      classes.itemText +
      " " +
      cx({
        [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
        [classes.itemTextMiniRTL]:
          rtlActive && this.props.miniActive && this.state.miniActive,
        [classes.itemTextRTL]: rtlActive
      });
    const collapseItemText =
      classes.collapseItemText +
      " " +
      cx({
        [classes.collapseItemTextMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.collapseItemTextMiniRTL]:
          rtlActive && this.props.miniActive && this.state.miniActive,
        [classes.collapseItemTextRTL]: rtlActive
      });
    const userWrapperClass =
      classes.user +
      " " +
      cx({
        [classes.whiteAfter]: bgColor === "white"
      });
    const caret =
      classes.caret +
      " " +
      cx({
        [classes.caretRTL]: rtlActive
      });
    const collapseItemMini =
      classes.collapseItemMini +
      " " +
      cx({
        [classes.collapseItemMiniRTL]: rtlActive
      });
    const photo =
      classes.photo +
      " " +
      cx({
        [classes.photoRTL]: rtlActive
      });
    var user = (
      <div className={userWrapperClass}>
        {/*<div className={photo}>
          <img src={avatar} className={classes.avatarImg} alt="..." />
        </div>*/}
        <List className={classes.list}>
          {/*<ListItem className={classes.item + " " + classes.userItem}>
            <NavLink
              to={"#"}
              className={classes.itemLink + " " + classes.userCollapseButton}
              onClick={() => this.openCollapse("openAvatar")}
            >
              <ListItemText
                primary={getData('adminData')? getData('adminData').name: null}
                // secondary={
                //   <b
                //     className={
                //       caret +
                //       " " +
                //       classes.userCaret +
                //       " " +
                //       (this.state.openAvatar ? classes.caretActive : "")
                //     }
                //   />
                // }
                disableTypography={true}
                className={itemText + " " + classes.userItemText}
              />
            </NavLink>
          </ListItem>*/}
          <ListItem
            className={classes.item + " " + classes.userItem}
            style={{ paddingLeft: "10px", paddingTop: "10px" }}
          >
            <NavLink
              to={"#"}
              className={classes.itemLink + " " + classes.userCollapseButton}
              onClick={() => this.openCollapse("openAvatar")}
              style={{ display: "flex" }}
            >
              <ListItemIcon className={classes.item}>
                <Icon color="action">
                  <SettingsApplications />
                </Icon>
              </ListItemIcon>
              <ListItemText
                primary="Settings"
                secondary={
                  <b
                    className={
                      caret +
                      " " +
                      classes.userCaret +
                      " " +
                      (this.state.openAvatar ? classes.caretActive : "")
                    }
                  />
                }
                disableTypography={true}
                className={itemText + " " + classes.userItemText}
              />
            </NavLink>
            <Collapse in={this.state.openAvatar} unmountOnExit>
              <List className="sidebar_menu_profile">
                <ListItem className={classes.collapseItem}>
                  <NavLink
                    to="#"
                    className={
                      classes.itemLink + " " + classes.userCollapseLinks
                    }
                  >
                    <span className={collapseItemMini}>
                      {rtlActive ? "و" : "P"}
                    </span>
                    <ListItemText
                      onClick={this.showHideProfileModel}
                      primary={rtlActive ? "إعدادات" : "Profile"}
                      disableTypography={true}
                      className={collapseItemText}
                    />
                  </NavLink>
                </ListItem>
                {/*}<ListItem className={classes.collapseItem}>
                  <NavLink
                    to="#"
                    className={
                      classes.itemLink + " " + classes.userCollapseLinks
                    }
                  >
                    <span className={collapseItemMini}>
                      {rtlActive ? "و" : "R"}
                    </span>
                    <ListItemText
                      onClick= {this.showHideResetPassModel}
                      primary={rtlActive ? "إعدادات" : "Reset Password"}
                      disableTypography={true}
                      className={collapseItemText}
                    />
                  </NavLink>
                </ListItem>*/}

                <ListItem className={classes.collapseItem}>
                  <NavLink
                    to="#"
                    className={
                      classes.itemLink + " " + classes.userCollapseLinks
                    }
                  >
                    <span className={collapseItemMini}>
                      {rtlActive ? "و" : "L"}
                    </span>
                    <ListItemText
                      onClick={this.showHideLogout}
                      primary={rtlActive ? "إعدادات" : "Logout"}
                      disableTypography={true}
                      className={collapseItemText}
                    />
                  </NavLink>
                </ListItem>
              </List>
            </Collapse>
          </ListItem>
        </List>
      </div>
    );
    var links = (
      <List className="sidebar_menu">
        {routes.map((prop, key) => {
          if (prop.redirect) {
            return null;
          }
          if (prop.hide) {
            return null;
          }
          if (
            prop.name === "Manage Users" &&
            getData("adminData").assignRoles.indexOf("Manage Users") === -1
          ) {
            return null;
          }
          if (
            prop.name === "Products" &&
            getData("adminData").assignRoles.indexOf("Products") === -1
          ) {
            return null;
          }
          if (
            prop.name === "Image Gallery" &&
            getData("adminData").assignRoles.indexOf("Image Gallery") === -1
          ) {
            return null;
          }
          if (
            prop.name === "Images Vetting" &&
            getData("adminData").assignRoles.indexOf("Images Vetting") === -1
          ) {
            return null;
          }
          if (
            prop.name === "Manage Notifications" &&
            getData("adminData").assignRoles.indexOf("Push Notifications") ===
            -1
          ) {
            return null;
          }
          // if(prop.name === "Manage Content" && getData('adminData').assignRoles.indexOf("Manage Content") === -1) {
          //   return null
          // }
          if (
            prop.name === "Manage Reports" &&
            getData("adminData").assignRoles.indexOf("Manage Reports") === -1
          ) {
            return null;
          }
          if (prop.collapse) {
            const navLinkClasses =
              classes.itemLink +
              " " +
              cx({
                [" " + classes.collapseActive]: this.activeRoute(prop.path)
              });
            const itemText =
              classes.itemText +
              " " +
              cx({
                [classes.itemTextMini]:
                  this.props.miniActive && this.state.miniActive,
                [classes.itemTextMiniRTL]:
                  rtlActive && this.props.miniActive && this.state.miniActive,
                [classes.itemTextRTL]: rtlActive
              });
            const collapseItemText =
              classes.collapseItemText +
              " " +
              cx({
                [classes.collapseItemTextMini]:
                  this.props.miniActive && this.state.miniActive,
                [classes.collapseItemTextMiniRTL]:
                  rtlActive && this.props.miniActive && this.state.miniActive,
                [classes.collapseItemTextRTL]: rtlActive
              });
            const itemIcon =
              classes.itemIcon +
              " " +
              cx({
                [classes.itemIconRTL]: rtlActive
              });
            const caret =
              classes.caret +
              " " +
              cx({
                [classes.caretRTL]: rtlActive
              });
            return (
              <ListItem key={key} className={classes.item}>
                <NavLink
                  to={"#"}
                  className={navLinkClasses}
                  onClick={() => this.openCollapse(prop.state)}
                >
                  <ListItemIcon className={itemIcon}>
                    {typeof prop.icon === "string" ? (
                      <Icon>{prop.icon}</Icon>
                    ) : (
                        <prop.icon />
                      )}
                  </ListItemIcon>
                  <ListItemText
                    primary={prop.name}
                    secondary={
                      <b
                        className={
                          caret +
                          " " +
                          (this.state[prop.state] ? classes.caretActive : "")
                        }
                      />
                    }
                    disableTypography={true}
                    className={itemText}
                  />
                </NavLink>
                <Collapse in={this.state[prop.state]} unmountOnExit>
                  <List className={classes.list + " " + classes.collapseList}>
                    {prop.views.map((prop, key) => {
                      if (prop.redirect) {
                        return null;
                      }
                      if (prop.hide) {
                        return null;
                      }
                      const navLinkClasses =
                        classes.collapseItemLink +
                        " " +
                        cx({
                          [" " + classes[color]]: this.activeRoute(prop.path)
                        });
                      const collapseItemMini =
                        classes.collapseItemMini +
                        " " +
                        cx({
                          [classes.collapseItemMiniRTL]: rtlActive
                        });
                      return (
                        <ListItem key={key} className={classes.collapseItem}>
                          <NavLink to={prop.path} className={navLinkClasses}>
                            <span className={collapseItemMini}>
                              {prop.mini}
                            </span>
                            <ListItemText
                              primary={prop.name}
                              disableTypography={true}
                              className={collapseItemText}
                            />
                          </NavLink>
                        </ListItem>
                      );
                    })}
                  </List>
                </Collapse>
              </ListItem>
            );
          }
          const navLinkClasses =
            classes.itemLink +
            " " +
            cx({
              [" " + classes[color]]: this.activeRoute(prop.path)
            });
          const itemText =
            classes.itemText +
            " " +
            cx({
              [classes.itemTextMini]:
                this.props.miniActive && this.state.miniActive,
              [classes.itemTextMiniRTL]:
                rtlActive && this.props.miniActive && this.state.miniActive,
              [classes.itemTextRTL]: rtlActive
            });
          const itemIcon =
            classes.itemIcon +
            " " +
            cx({
              [classes.itemIconRTL]: rtlActive
            });
          return (
            <ListItem key={key} className={classes.item}>
              <NavLink to={prop.path} className={navLinkClasses}>
                <ListItemIcon className={itemIcon}>
                  {typeof prop.icon === "string" ? (
                    <Icon>{prop.icon}</Icon>
                  ) : (
                      <prop.icon />
                    )}
                </ListItemIcon>
                <ListItemText
                  primary={prop.name}
                  disableTypography={true}
                  className={itemText}
                />
              </NavLink>
            </ListItem>
          );
        })}
      </List>
    );

    // const logoNormal =
    //   classes.logoNormal +
    //   " " +
    //   cx({
    //     [classes.logoNormalSidebarMini]:
    //       this.props.miniActive && this.state.miniActive,
    //     [classes.logoNormalSidebarMiniRTL]:
    //       rtlActive && this.props.miniActive && this.state.miniActive,
    //     [classes.logoNormalRTL]: rtlActive
    //   });
    // const logoMini =
    //   classes.logoMini +
    //   " " +
    //   cx({
    //     [classes.logoMiniRTL]: rtlActive
    //   });
    const logoClasses =
      classes.logo +
      " " +
      cx({
        [classes.whiteAfter]: bgColor === "white"
      });
    var brand = (
      <div className={logoClasses}>
        <a
          className="side_bar_logo"
          href=""
          style={{ color: "#ffffff", fontSize: "x-large", fontWeight: "900" }}
        >
          {<img src={iseas} alt="logo" className={classes.img} />}
          {/*this.props.miniActive && this.state.miniActive ? 'F' : 'F E V O'*/}
        </a>
        {/* <a href="https://www.creative-tim.com" className={logoNormal}>
          {logoText}
        </a> */}
      </div>
    );
    const drawerPaper =
      classes.drawerPaper +
      " " +
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.drawerPaperRTL]: rtlActive
      });
    const sidebarWrapper =
      classes.sidebarWrapper +
      " " +
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.sidebarWrapperWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });
    return (
      <div ref="mainPanel">
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={rtlActive ? "left" : "right"}
            open={this.props.open}
            classes={{
              paper: drawerPaper + " " + classes[bgColor + "Background"]
            }}
            onClose={this.props.handleDrawerToggle}
            ModalProps={{
              keepMounted: true // Better open performance on mobile.
            }}
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper}
              user={user}
              //headerLinks={<HeaderLinks rtlActive={rtlActive} />}
              links={links}
            />
            {image !== undefined ? (
              <div
                className={classes.background}
                style={{ backgroundImage: "url(" + image + ")" }}
              />
            ) : null}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            onMouseOver={() => this.setState({ miniActive: false })}
            onMouseOut={() => this.setState({ miniActive: true })}
            anchor={rtlActive ? "right" : "left"}
            variant="permanent"
            open
            classes={{
              paper: drawerPaper + " " + classes[bgColor + "Background"]
            }}
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper + "sidebar_custom"}
              user={user}
              links={links}
            />
            {image !== undefined ? (
              <div
                className={classes.background}
                style={{ backgroundImage: "url(" + image + ")" }}
              />
            ) : null}
          </Drawer>
        </Hidden>
        <LogoutImpl show={this.state.show} onHide={this.showHideLogout} />
        <UpdateProfile
          show={this.state.showProfileModel}
          handleClose={this.showHideProfileModel}
          openResetPassword={this.openResetPassword}
        />
        <ResetPassword
          show={this.state.showResetPassModel}
          handleClose={this.showHideResetPassModel}
        />
      </div>
    );
  }
}

Sidebar.defaultProps = {
  bgColor: "blue"
};

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  bgColor: PropTypes.oneOf(["white", "black", "blue"]),
  rtlActive: PropTypes.bool,
  color: PropTypes.oneOf([
    "white",
    "red",
    "orange",
    "green",
    "blue",
    "purple",
    "rose",
    "iseas"
  ]),
  logo: PropTypes.string,
  logoText: PropTypes.string,
  image: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object)
};

export default withStyles(sidebarStyle)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx